module.exports = __webpack_public_path__ + "static/img/6.205109e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/sp/6.png
// module id = a0oW
// module chunks = 0